import { CircularProgress, InputAdornment } from "@mui/material";

import TextField from "./text-field";

const DiscountCode = ({ className, InputProps = {}, isApplying, onApply, ...props }) => {
  return (
    <TextField
      className={`discount-field filled${!!className ? ` ${className}` : ""}`}
      label="Discount Code"
      onKeyPress={(e) => {
        if (e.key === "Enter") onApply();
      }}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <button className="apply-button" onClick={onApply} disabled={isApplying}>
              Apply{isApplying && <CircularProgress />}
            </button>
          </InputAdornment>
        ),
        ...InputProps,
      }}
      {...props}
    />
  );
};

export default DiscountCode;
